import type { Theme } from './useThemeStore';

/**
 * The single place the document learns about the theme.
 *
 * It is called from two directions — the provider effect on mount and on any
 * store change, and the view transition below, which needs the attribute
 * written *inside* its callback so the browser can snapshot the new colours.
 * Writing the same two properties is idempotent, so the pair never fight.
 */
export function applyThemeToDocument(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  document.documentElement.style.colorScheme = theme;
}
